import App from "../layouts/App";
import CrossPng from "/Cross.png";

export default function Testimonial() {
	return (
		<App>
			<div>
				<main className="AboutMain">
					<div className="AboutDiv">
						<h4>The Story of Your Life On Purpose!</h4>
						<hr className="Divider"></hr>
						<p className="AboutPara">
							Welcome to a place where our stories intertwine with His—the story of
							Jesus Christ on the cross. Though each of us may walk different paths,
							our journeys are woven together through faith in Him, the Creator of us
							all. In this shared tapestry, we find unity, love, and purpose as we
							trust in the One who holds the world in His hands.
						</p>

						<div className="img-container">
							<div className="img-box">
								<img src={CrossPng} alt="Cross" />
							</div>
						</div>
					</div>
				</main>
			</div>
		</App>
	);
}
